import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectEstimatedTradeCostComparisonWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[
        WidgetType.EST_TRADE_COST_COMPARISON_WIDGET
    ];

export const selectEstimatedTradeCostComparisonWidgetState = (
    state: State,
    widgetKey: string
) => selectEstimatedTradeCostComparisonWidgetsState(state)[widgetKey];
